<template>
  <v-row align="center" justify="space-around">
    <v-col cols="6">
      <v-row>
        <v-col cols="12">
          <v-text-field 
            v-model="password"
            :type="showPassword ? 'text' : 'password'" 
            prepend-icon="lock" 
            :label="$t('LoginPage.Form.password')" 
            required 
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            @keyup.enter="$emit('enter')"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field 
            v-model="confirmPassword"
            :type="showConfirmPassword ? 'text' : 'password'" 
            prepend-icon="lock" 
            :label="$t('LoginPage.Form.confirmPassword')" 
            :hint="$t('LoginPage.PasswordForm.help')" 
            required
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showConfirmPassword = !showConfirmPassword"
            @keyup.enter="$emit('enter')"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-divider vertical></v-divider>
    <v-col cols="4">
      <h3>{{ $t('Security.Password.rules') }}</h3>
      <v-list dense>
        <v-list-item v-for="(rule, index) in rules" :key="'rule_' + index">
          <v-list-item-icon>
            <v-icon v-if="rule.isValid" color="success">check_box</v-icon>
            <v-icon v-else>check_box_outline_blank</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ rule.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'

export default {
  name: 'PasswordForm',
  props: {
    value: {type: String, required: true}
  },
  data () {
    return {
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false
    }
  },
  computed: {
    password: {
      get () {
        return this.value
      },
      set (value) {
        return this.$emit('input', value)
      }
    },
    rules () {
      return [
        { text: this.$t('Security.Password.minLength'), isValid: this.$v.password.required && this.$v.password.minLength },
        { text: this.$t('Security.Password.upper'), isValid: this.$v.password.required && this.$v.password.mustHasUpper },
        { text: this.$t('Security.Password.lower'), isValid: this.$v.password.required && this.$v.password.mustHasLower },
        { text: this.$t('Security.Password.number'), isValid: this.$v.password.required && this.$v.password.mustHasNumber },
        { text: this.$t('Security.Password.special'), isValid: this.$v.password.required && this.$v.password.mustHasSymbol }
      ]
    }
  },
  watch: {
    '$v.$invalid' (value) {
      this.$emit('validation', !value)
    },
    'value' () {
      this.confirmPassword = ''
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(10),
      mustHasUpper: helpers.regex('mustHasUpper', /(?=.*[A-Z])/),
      mustHasLower: helpers.regex('mustHasLower', /(?=.*[a-z])/),
      mustHasNumber: helpers.regex('mustHasNumber', /(?=.*\d)/),
      mustHasSymbol: helpers.regex('mustHasSymbol', /(?=.*[-+_!@#$%^&*.,?])/),
    },
    confirmPassword: {
      sameAsPassword: sameAs('password')
    }
  }
}
</script>
